import L from 'leaflet';

import 'leaflet/dist/leaflet.css';

import Map from './Map';
import common from './common/index';
import util from './utils/util';
import geometry from './geometry/index';
import layer from './layer/index';
import render from './render/index';
import source from './source/index';
import math from './math/index';
import tool from './tools/index';
import feedback from './feedback/index';
import snap from './snap/index';
import edit from './edit/index';
import algorithm from './algorithm/index';
import transform from './transform/index';
import highlight from './highlight/index';
import symbol from './symbol/index';

const NaviMap = {
    core: L,
    Map,
    common,
    util,
    geometry,
    layer,
    render,
    source,
    math,
    tool,
    feedback,
    snap,
    edit,
    algorithm,
    transform,
    highlight,
    symbol
};

export default NaviMap;
